<footer>
  <div class="info-links">
    <div class="d-flex flex-column">
      <strong>Suporte</strong>

      <a href="mailto:sac@ninamob.com">sac@ninamob.com</a>
    </div>
    <!-- <div class="d-flex flex-column">
      <strong>Metodologia</strong>

      <a>Indicadores</a>
      <a>Coleta de dados</a>
    </div> -->
    <div class="d-flex flex-column">
      <strong>Sobre nós</strong>

      <a href="https://portal.superninamob.com/" target="_blank">Website</a>
      <a href="https://portal.superninamob.com/blog" target="_blank">Blog</a>
    </div>
  </div>
  <div class="social-networks">
    <div class="social-links">
      <a href="https://www.linkedin.com/company/superninamob/" target="_blank"
        ><img src="assets/icons/mdi_linkedin.svg" alt=""
      /></a>
      <a href="https://www.instagram.com/superninamob/" target="_blank"
        ><img src="assets/icons/mdi_instagram.svg" alt=""
      /></a>
    </div>

    <img src="assets/icons/logo.svg" style="cursor: pointer; width: 11.25rem" />
  </div>
</footer>
